import { Language } from "@moodys/cre-cpm-client-apis.apis.services.auth"
import { Locale } from "antd/lib/locale-provider"
import localeEn from "antd/lib/locale/en_US"
import localeDe from "antd/lib/locale/de_DE"
import { LocaleData } from "i18n-iso-countries"
import countriesEn from "i18n-iso-countries/langs/en.json"
import countriesDe from "i18n-iso-countries/langs/de.json"

export const antdLocales: { [key in Language]: Locale } = {
  en: localeEn,
  de: localeDe
}

export const countriesLocales: { [key in Language]: LocaleData } = {
  en: countriesEn,
  de: countriesDe
}
